import axios from 'axios';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../../styles/GlobalComponents';

import Spinner from '../../../components/common/Spinner';

import { P1, P2, P3 } from '../../../styles/FontStyles';

import ReactCodeInput from 'react-code-input';
import { color } from '../../../styles/GlobalStyles';
import { createWithdrawPartner } from './Withdraw.actions';

import { useAppSelector } from '../../../app/hooks';
import {
  ErrorToast,
  SuccessToast
} from '../../../components/common/Toasts/Toasts';

interface TwoFASetupProps {
  setStep: Dispatch<SetStateAction<number>>;
  amount: string;
  fee: any;
  selectedWallet: any;
  selected: any;
  networkType: any;
  setAmount: any;
  selectedToken: any;
}

export const TwoFASetup = ({
  setStep,
  amount,
  fee,
  selectedWallet,
  selected,
  networkType,
  setAmount,
  selectedToken
}: TwoFASetupProps) => {
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const dispatch = useDispatch();

  const { loading } = useAppSelector((state) => state.wallets);
  const { verificationStatus } = useAppSelector((state) => state.settings);
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/user/balance/sumsub/withdraw/email/code`, {
        amount: parseInt(amount) - parseInt(fee),
        userWalletId: selectedWallet.id,
        networkType,
        networkCurrencyType: selectedToken.token.toLowerCase()
      });

      SuccessToast('Code sent successfully');
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = () => {
    dispatch(
      createWithdrawPartner({
        amount: parseInt(amount),
        userWalletId: selectedWallet.id,
        setStep,
        emailCode: code,
        twoFACode: code2Fa,
        networkType,
        setAmount,
        networkCurrencyType: selectedToken.token.toLowerCase(),
        setLoadingCode
      })
    );
  };

  return (
    <div>
      {loading || loadingCode ? (
        <Spinner />
      ) : (
        <>
          <Flexed between>
            <P3 mb='10' mt='10'>
              Enter the verification code that was sent to your security email
              address.
            </P3>
            {/* <P2
              bold
              style={{ cursor: 'pointer' }}
              color={color.colors.primary900}
              onClick={() => sendCode()}>
              Send Code
            </P2> */}
          </Flexed>

          <SecurityCodeWrapper>
            <ReactCodeInput
              fields={7}
              value={code}
              onChange={setCode}
              type={'number'}
              name='phone code'
              inputMode='numeric'
            />
          </SecurityCodeWrapper>
          {/* <P3 color={color.colors.neutral500} mb='40'>
            {isCodeSent && `Enter the 7 digit code sent to ${user?.email}`}
          </P3> */}

          <Flexed justifyCenter>
            <Button
              maxWidth='200px'
              m='30px 0 30px 0'
              onClick={() => sendCode()}>
              Send code
            </Button>
          </Flexed>

          {verificationStatus && (
            <div>
              <Flexed justifyCenter>
                <P1 bold>Verification</P1>
              </Flexed>

              <Flexed justifyCenter>
                <P3 mb='10' mt='10'>
                  Enter the 6 digit code from your two factor authenticator APP
                </P3>
              </Flexed>

              <SecurityCodeWrapper is2Fa>
                <ReactCodeInput
                  fields={6}
                  value={code2Fa}
                  onChange={setCode2Fa}
                  type={'number'}
                  name='phone code2 '
                  inputMode='numeric'
                />
              </SecurityCodeWrapper>
            </div>
          )}
          <Flexed justifyCenter>
            <Button
              maxWidth='300px'
              m='30px 0 10px 0'
              disabled={code === '' ? true : false}
              onClick={onHandleSubmit}>
              Submit withdrawal order
            </Button>
          </Flexed>
        </>
      )}
    </div>
  );
};
